import React from 'react'
import { Fade, ListItemAvatar, ListItemText } from '@mui/material'
import { Body2, Checkbox, UserAvatar } from '@collaborate-health/uikit'
import { UserCheckInItemProps } from './UserCheckInItem.types'
import { StyledListItem } from './UserCheckInItem.styles'

const UserCheckInItem: React.FC<UserCheckInItemProps> = ({ user, selected, onSelect, onDeselect }) => {
  return (
    <Fade in>
      <StyledListItem
        disableGutters
        onClick={() => {
          if (selected) {
            onDeselect(user)
          } else {
            onSelect(user)
          }
        }}
      >
        <Checkbox checked={selected} />
        <ListItemAvatar>
          <UserAvatar user={user} style={undefined} />
        </ListItemAvatar>
        <ListItemText
          primary={
            <Body2 noWrap>
              {user.displayName} {user.thisUser && '(you)'}
            </Body2>
          }
        />
      </StyledListItem>
    </Fade>
  )
}

export default UserCheckInItem

